export class DrugPasteValuesModalData {
  constructor(public readonly isPharma: boolean) {}
}
